<template>
  <div class="explanation">
    <h2 class="title">Summary</h2>
    <div class="visual-container">
      <div class="visual">
        <div class="left">
          <p class="text-correct">Correct answer:</p>
          <div>
            <img class="coin" :src="require(`@/assets/practices/saving_money/coin_${typeOne}.svg`)" alt="coin" />
            x {{ answerOne.value }}
          </div>
          <p class="text-incorrect">Your answer:</p>
          <div class="user-answer">
            <div v-for="(key, coin, renderOne) in userAnswer[0]" :key="renderOne">
              <img class="coin" :src="require(`@/assets/practices/saving_money/coin_${coin}.svg`)" alt="coin" />
              x {{ key }}
            </div>
          </div>
        </div>
        <div class="right">
          <img class="pig" :src="require(`@/assets/practices/saving_money/pig_${typeOne}.svg`)" alt="pig" />
          <div id="answer-animation-one"></div>
        </div>
      </div>
      <div class="visual">
        <div class="left">
          <p class="text-correct">Correct answer:</p>
          <div>
            <img class="coin" :src="require(`@/assets/practices/saving_money/coin_${typeTwo}.svg`)" alt="coin" />
            x {{ answerTwo.value }}
          </div>
          <p class="text-incorrect">Your answer:</p>
          <div class="user-answer">
            <div v-for="(key, coin, renderTwo) in userAnswer[1]" :key="renderTwo">
              <img class="coin" :src="require(`@/assets/practices/saving_money/coin_${coin}.svg`)" alt="coin" />
              x {{ key }}
            </div>
          </div>
        </div>
        <div class="right">
          <img class="pig" :src="require(`@/assets/practices/saving_money/pig_${typeTwo}.svg`)" alt="pig" />
          <div id="answer-animation-two"></div>
        </div>
      </div>
    </div>
    <p class="text">
      Remember to take notice of the
      <span class="highlight">color</span>, <span class="highlight">shape</span> and
      <span class="highlight">value</span> of each coin.
    </p>
    <img class="button" src="@/assets/practices/saving_money/button_exit.svg" alt="exit" @click="closeExplanation" />
  </div>
</template>

<script>
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Explanation',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Pig: () => import('@/components/practices/saving_money/Pig.vue'),
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    correctCoinOne: Object,
    // eslint-disable-next-line vue/require-default-prop
    correctCoinTwo: Object,
    // eslint-disable-next-line vue/require-default-prop
    typeOne: String,
    // eslint-disable-next-line vue/require-default-prop
    typeTwo: String,
    // eslint-disable-next-line vue/require-default-prop
    userAnswer: Array,
    // eslint-disable-next-line vue/require-default-prop
    answerLeft: String,
    // eslint-disable-next-line vue/require-default-prop
    answerRight: String,
  },
  data: () => ({
    answerOne: { image: null, value: null },
    answerTwo: { image: null, value: null },
    renderOne: 0,
    renderTwo: 0,
  }),
  mounted() {
    this.getAnswerValueOne(this.typeOne);
    this.getAnswerValueTwo(this.typeTwo);

    // ANIMATIONS
    lottie.loadAnimation({
      container: document.getElementById('answer-animation-one'),
      autoplay: true,
      loop: true,
      path: `/assets/practices/saving_money/animations/explanation_${this.answerLeft}.json`,
    });
    lottie.loadAnimation({
      container: document.getElementById('answer-animation-two'),
      autoplay: true,
      loop: true,
      path: `/assets/practices/saving_money/animations/explanation_${this.answerRight}.json`,
    });
  },
  methods: {
    closeExplanation() {
      sounds.globalButton.play();
      this.$store.state.savingMoney.explanationStatus = false;
    },
    getAnswerValueOne(prop) {
      if (prop === 'penny') {
        this.answerOne.image = '@/assets/practices/saving_money/coin_penny.svg';
        this.answerOne.value = this.correctCoinOne.pennies;
      }
      if (prop === 'nickel') {
        this.answerOne.image = '@/assets/practices/saving_money/coin_nickel.svg';
        this.answerOne.value = this.correctCoinOne.nickels;
      }
      if (prop === 'dime') {
        this.answerOne.image = '@/assets/practices/saving_money/coin_dime.svg';
        this.answerOne.value = this.correctCoinOne.dimes;
      }
      if (prop === 'quarter') {
        this.answerOne.image = '@/assets/practices/saving_money/coin_quarter.svg';
        this.answerOne.value = this.correctCoinOne.quarters;
      } else {
        console.log('Error in Explanation:getAnswerValueOne()...');
      }
    },
    getAnswerValueTwo(prop) {
      if (prop === 'penny') {
        this.answerOne.image = '@/assets/practices/saving_money/coin_penny.svg';
        this.answerTwo.value = this.correctCoinTwo.pennies;
      }
      if (prop === 'nickel') {
        this.answerOne.image = '@/assets/practices/saving_money/coin_nickel.svg';
        this.answerTwo.value = this.correctCoinTwo.nickels;
      }
      if (prop === 'dime') {
        this.answerOne.image = '@/assets/practices/saving_money/coin_dime.svg';
        this.answerTwo.value = this.correctCoinTwo.dimes;
      }
      if (prop === 'quarter') {
        this.answerOne.image = '@/assets/practices/saving_money/coin_quarter.svg';
        this.answerTwo.value = this.correctCoinTwo.quarters;
      } else {
        console.log('Error in Explanation:getAnswerValueTwo()...');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.explanation {
  @include flex-center;
  background-color: #000000dd;
  color: $saving-money-color-text-explanation;
  flex-direction: column;
  font-size: 0.8em;
  height: 100vh;
  position: absolute;
  width: 100vw;
  z-index: 10;

  * {
    text-align: center;
    width: 95%;
  }

  .title {
    color: #fff820;
  }

  .text {
    line-height: 1.5;
    margin-top: 2em;
  }

  .highlight {
    color: #00b9ff;
  }

  .button {
    cursor: pointer;
    margin: 0.25em 0;
    height: 7vh;
  }

  .visual-container {
    @include flex-center;
    margin: 1em 0;

    .visual {
      @include flex-center;

      &:first-child {
        border-right: white solid 5px;
      }

      .left {
        width: 70%;

        .text-correct {
          color: #20ff27;
        }

        .answer-correct {
          align-items: center;
          display: flex;
          flex-direction: row;

          * {
            width: min-content;
          }
        }

        .text-incorrect {
          color: #ff2020;
          margin-top: 0.5em;
        }

        .user-answer {
          display: grid;
          grid-template-columns: 1fr 1fr;
        }

        .coin {
          height: 2.25em;
          width: 2.25em;
        }
      }

      .right {
        @include flex-center;
        flex-direction: column;
        width: 30%;

        .pig,
        #answer-animation-one,
        #answer-animation-two {
          $pig-size: 80%;
          height: $pig-size;
          margin: 0.5em 0;
          width: $pig-size;
        }
      }
    }
  }
}

@media (max-aspect-ratio: 8/5) {
  .explanation {
    .button {
      height: 8vh;
    }
  }
}
</style>
